<template>
    <SwitchTabs :pickDatas="pickData" :current="currentPicked" @switch="tabSwitch"/>
</template>

<script>
import SwitchTabs from "./SwitchTabs";

export default {
    name: "TimePicker",
    props: ["pickData", "currentPicked"],
    components: {
        SwitchTabs
    },
    data() {
        return {
            currentIdx: this.currentPicked
        };
    },
    watch: {
        currentPicked() {
            this.currentIdx = this.currentPicked;
        }
    },
    methods: {
        tabSwitch(item) {
            const end = new Date();
            const start = new Date();
            if (item.value instanceof Array) {
                start.setTime(start.getTime() - 3600 * 1000 * 24 * (item.value[1] - 1));
                end.setTime(end.getTime() - 3600 * 1000 * 24 * (item.value[0] - 1));
            } else {
                start.setTime(start.getTime() - 3600 * 1000 * 24 * (item.value - 1));
            }

            this.$emit("timeChange", [
                this.zhiji.dateFormat(start, "YYYY/MM/DD"),
                this.zhiji.dateFormat(end, "YYYY/MM/DD")
            ]);
        }
    }
};
</script>

<style lang="scss" scoped>
.time-picker-group {
    background: #ffffff;
    border: 1px solid #d9e4ef;
    border-radius: 4px;
    height: 40px;
    font-size: 0;
    margin-right: 16px;
}
</style>

